/* FIFTYBIKES theme: menu, bag drawer (Shopify AJAX cart), variant picker, clips. */
(function () {
  var FB = window.FB || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function money(cents) {
    var fmt = FB.moneyFormat || '${{amount}}';
    var n = (cents / 100);
    var withCommas = function (x, d) { return x.toFixed(d).replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return withCommas(n, 0);
      if (k === 'amount_with_comma_separator') return n.toFixed(2).replace('.', ',');
      return withCommas(n, 2);
    });
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  /* Menu */
  var mb = $('#menu-btn'), nv = $('#nav');
  if (mb && nv) mb.addEventListener('click', function () { var o = nv.classList.toggle('open'); mb.setAttribute('aria-expanded', o); });

  /* Drawer */
  var drawer = $('#drawer'), scrim = $('#scrim');
  function openBag() { if (!drawer) return; drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); scrim.hidden = false; }
  function closeBag() { if (!drawer) return; drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); scrim.hidden = true; }
  var bagBtn = $('#bag-btn');
  if (bagBtn && drawer) bagBtn.addEventListener('click', function (e) { e.preventDefault(); refreshCart().then(openBag); });
  if ($('#bag-close')) $('#bag-close').addEventListener('click', closeBag);
  if (scrim) scrim.addEventListener('click', closeBag);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeBag(); });

  function renderCart(cart) {
    $$('[data-bag-count]').forEach(function (el) { el.textContent = cart.item_count; });
    var lines = $('#lines'); if (!lines) return;
    if (!cart.items.length) { lines.innerHTML = '<p class="empty">Your bag is empty.</p>'; }
    else {
      lines.innerHTML = cart.items.map(function (it, i) {
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') : '';
        var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="mono muted">' + esc(it.variant_title) + '</div>' : '';
        return '<div class="line">' +
          (img ? '<img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="">' : '<span></span>') +
          '<div><div class="nm">' + esc(it.product_title) + '</div>' + variant +
          '<div class="qty"><button type="button" data-line="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="Remove one">−</button>' + it.quantity +
          '<button type="button" data-line="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="Add one">+</button></div></div>' +
          '<div class="mono">' + money(it.final_line_price) + '</div></div>';
      }).join('');
    }
    var st = $('#subtotal'); if (st) st.textContent = money(cart.total_price);
  }
  function refreshCart() {
    return fetch((FB.routes && FB.routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { renderCart(c); return c; }).catch(function () {});
  }
  var linesEl = $('#lines');
  if (linesEl) linesEl.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line]'); if (!b) return;
    fetch((FB.routes && FB.routes.change || '/cart/change') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: +b.dataset.line, quantity: Math.max(0, +b.dataset.q) })
    }).then(function (r) { return r.json(); }).then(renderCart);
  });

  /* Product page: options -> variant */
  var pdp = $('[data-product]');
  if (pdp) {
    var variants = [];
    try { variants = JSON.parse(($('[data-variants]') || {}).textContent || '[]'); } catch (e) {}
    var form = $('#product-form'), idInput = $('[data-variant-id]'), priceEl = $('[data-price]'), addBtn = $('[data-add]'), note = $('[data-note]');
    var hasOptions = $$('[data-opt]', pdp).length > 0;
    var qtyInput = $('[data-qty-input]', pdp);
    $$('[data-qty]', pdp).forEach(function (b) { b.addEventListener('click', function () { if (!qtyInput) return; qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + (+b.dataset.qty)); }); });
    /* Tap a photo to see it full size */
    $$('img[data-zoom]', pdp).forEach(function (img) {
      img.addEventListener('click', function () {
        var ov = document.createElement('div'); ov.className = 'zoom'; ov.setAttribute('role', 'dialog'); ov.setAttribute('aria-label', 'Photo');
        ov.innerHTML = '<button class="zoom-close" type="button">Close</button><img alt="">';
        ov.querySelector('img').src = img.dataset.zoom; ov.querySelector('img').alt = img.alt || '';
        function close() { ov.remove(); document.removeEventListener('keydown', onKey); }
        function onKey(e) { if (e.key === 'Escape') close(); }
        ov.addEventListener('click', close); document.addEventListener('keydown', onKey);
        document.body.appendChild(ov);
      });
    });
    if (!$$('.sizes', pdp).length) pdp.classList.add('sized');
    var selected = []; var chosen = {};
    $$('[data-opt]', pdp).forEach(function (b) { if (b.getAttribute('aria-pressed') === 'true') selected[+b.dataset.opt] = b.dataset.value; });
    // Sizes start unpicked so shoppers choose on purpose; colors keep their default.
    $$('.sizes [data-opt]', pdp).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
    function optCount() { var n = 0; $$('.opt', pdp).forEach(function () { n++; }); return n; }
    function update() {
      var v = variants.filter(function (x) { return x.options.every(function (o, i) { return o === selected[i]; }); })[0];
      var allPicked = Object.keys(chosen).length + $$('.colors', pdp).length >= optCount();
      if (v) {
        idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price);
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'Add to bag' : 'Sold out';
        if (allPicked && window.history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
      }
    }
    $$('[data-opt]', pdp).forEach(function (b) {
      b.addEventListener('click', function () {
        var i = +b.dataset.opt;
        $$('[data-opt="' + i + '"]', pdp).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        selected[i] = b.dataset.value; chosen[i] = true;
        if (b.closest('.sizes')) pdp.classList.add('sized');
        var lbl = $('[data-opt-name="' + i + '"]', pdp); if (lbl) lbl.textContent = b.dataset.value;
        if (note) note.textContent = '';
        update();
      });
    });
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (hasOptions && $$('.sizes', pdp).length && !$$('.sizes [aria-pressed="true"]', pdp).length) { if (note) note.textContent = 'Choose a size first.'; return; }
      addBtn.disabled = true;
      fetch((FB.routes && FB.routes.add || '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +idInput.value, quantity: Math.max(1, parseInt((qtyInput && qtyInput.value) || '1', 10) || 1) }] })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          addBtn.disabled = false;
          if (!res.ok) { if (note) note.textContent = res.j.description || 'Could not add this item.'; return; }
          refreshCart().then(openBag);
        }).catch(function () { addBtn.disabled = false; form.submit(); });
    });
  }

  /* Cards: hover clips on desktop */
  if (!matchMedia('(hover:none)').matches) {
    $$('.card').forEach(function (c) {
      var v = c.querySelector('video[data-src]'); if (!v) return;
      c.addEventListener('mouseenter', function () { if (!v.src) { v.src = v.dataset.src; v.addEventListener('loadeddata', function () { v.classList.add('ready'); }, { once: true }); } v.play().catch(function () {}); });
      c.addEventListener('mouseleave', function () { v.pause(); });
    });
  }

  /* Swipeable thumbnails: dots follow the swipe; arrows on desktop */
  $$('[data-slides]').forEach(function (track) {
    var ph = track.parentElement, dots = $$('.dots i', ph);
    if (dots.length < 2) return;
    var t;
    function idx() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { var k = idx(); dots.forEach(function (d, n) { d.classList.toggle('on', n === k); }); }, 60); }, { passive: true });
    $$('[data-slide]', ph).forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); var k = Math.min(dots.length - 1, Math.max(0, idx() + (+b.dataset.slide))); track.scrollTo({ left: k * track.clientWidth, behavior: 'smooth' }); });
    });
  });

  /* Headline words */
  $$('[data-words]').forEach(function (hw) {
    function play() { hw.classList.remove('go'); void hw.offsetWidth; hw.classList.add('go'); }
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) play(); }); }, { threshold: .6 }).observe(hw); else play();
  });

  /* TikTok sound */
  $$('[data-sound]').forEach(function (b) {
    var v = b.parentElement.querySelector('video'); if (!v) return;
    b.addEventListener('click', function () { v.muted = !v.muted; if (!v.muted) { v.currentTime = 0; v.play().catch(function () {}); } b.textContent = v.muted ? 'Tap for sound' : 'Sound on'; b.setAttribute('aria-pressed', !v.muted); });
  });

  if (matchMedia('(prefers-reduced-motion:reduce)').matches) $$('video[autoplay]').forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); });
})();
